import "../styles/notifications.css";

export default function NotificationsPage() {
  return (
    <main className="notifications-page">
      <h1 className="notifications-title">Notificaciones</h1>
      <section className="notifications-list">
        <p className="notifications-empty">
          Esta seccion volvera en una siguiente fase. Por ahora estamos priorizando productos, reservas y perfil.
        </p>
      </section>
    </main>
  );
}
